
    import { Component, Vue } from 'vue-property-decorator';
    import { IFooterImages } from '@/interfaces/FooterImages/IFooterImages';
    import footerImagesAPI from '@/store/footerImagesAPI';

    @Component({
        components: {
            
        }
    })
    export default class FooterImages extends Vue {
        private AllImagefiles: any = [] as Array<IFooterImages>;
        
        private async getallfiles() {
            this.AllImagefiles = await footerImagesAPI.getimagefiles();            
        }
        private converttoblob(base64Data: any) {
            var sliceSize = 1024;
            var contentType="image/png" // have to get the appropriate contenttype
            var byteCharacters = atob(base64Data);
            var bytesLength = byteCharacters.length;
            var slicesCount = Math.ceil(bytesLength / sliceSize);
            var byteArrays = new Array(slicesCount);
            for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                var begin = sliceIndex * sliceSize;
                var end = Math.min(begin + sliceSize, bytesLength);
                var bytes = new Array(end - begin);
                for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return window.URL.createObjectURL(new Blob(byteArrays, { type: contentType }));
        }
        private async deleteimagefile(imagefileid: number) {
            if (confirm("Are you sure you want to delete the Image?")) {               
                await footerImagesAPI.deleteimagefile(imagefileid).then((result) => {
                    if (result) {
                        alert("Deleted Successfully");
                        this.getallfiles();
                    }
                });          
            }
        }
       
        private async mounted() {
            this.getallfiles();
        }
    }
